// // // // pages/ArtisanDisbursements.jsx
// // // import React, { useState, useEffect } from 'react';
// // // import { 
// // //   FaSearch,
// // //   FaMoneyBillWave,
// // //   FaClock,
// // //   FaCheckCircle,
// // //   FaEye,
// // //   FaTimes,
// // //   FaUser,
// // //   FaProjectDiagram,
// // //   FaCalendarAlt,
// // //   FaReceipt,
// // //   FaWallet,
// // //   FaArrowRight
// // // } from 'react-icons/fa';
// // // import withAuth from '../../auth/WithAuth';
// // // import { toast } from 'react-toastify';
// // // import './payments.scss';
// // // import { serverUrlAuth } from '../../../serverUrl';
// // // import FurnitureNavbar from '../../../components/layout/Nav';

// // // const ArtisanDisbursements = () => {
// // //   const [disbursements, setDisbursements] = useState([]);
// // //   const [loading, setLoading] = useState(true);
// // //   const [showDetailModal, setShowDetailModal] = useState(false);
// // //   const [selectedDisbursement, setSelectedDisbursement] = useState(null);
// // //   const [disbursementDetail, setDisbursementDetail] = useState(null);
// // //   const [detailLoading, setDetailLoading] = useState(false);
// // //   const [filters, setFilters] = useState({
// // //     search: '',
// // //     payment_method: 'all',
// // //   });

// // //   // Stats
// // //   const [stats, setStats] = useState({
// // //     total: 0,
// // //     total_amount: 0,
// // //     mpesa_count: 0,
// // //     bank_count: 0,
// // //   });

// // //   useEffect(() => {
// // //     fetchDisbursements();
// // //   }, []);

// // //   const fetchDisbursements = async () => {
// // //     setLoading(true);
// // //     try {
// // //       const response = await serverUrlAuth.get('disbursement/my-disbursements/');
      
// // //       let data = response.data;
// // //       let disbursementsList = [];
      
// // //       // Handle nested data structure
// // //       if (data.disbursements && Array.isArray(data.disbursements)) {
// // //         disbursementsList = data.disbursements;
// // //       } else if (Array.isArray(data)) {
// // //         disbursementsList = data;
// // //       } else if (data.results && Array.isArray(data.results)) {
// // //         disbursementsList = data.results;
// // //       }
      
// // //       setDisbursements(disbursementsList);
// // //       updateStats(disbursementsList);
// // //     } catch (error) {
// // //       console.error('Error fetching disbursements:', error);
// // //       toast.error('Failed to load payment history');
// // //       setDisbursements([]);
// // //     } finally {
// // //       setLoading(false);
// // //     }
// // //   };

// // //   const updateStats = (data) => {
// // //     const total = data.length;
// // //     const total_amount = data.reduce((sum, d) => sum + parseFloat(d.amount || 0), 0);
// // //     const mpesa_count = data.filter(d => d.payment_method === 'mpesa').length;
// // //     const bank_count = data.filter(d => d.payment_method === 'bank').length;
    
// // //     setStats({ total, total_amount, mpesa_count, bank_count });
// // //   };

// // //   const fetchDisbursementDetail = async (disbursementId) => {
// // //     setDetailLoading(true);
// // //     try {
// // //       const response = await serverUrlAuth.get(`disbursement/my-disbursements/${disbursementId}/`);
      
// // //       let data = response.data;
      
// // //       // Handle nested data structure
// // //       if (data.disbursement) {
// // //         data = data.disbursement;
// // //       }
      
// // //       setDisbursementDetail(data);
// // //     } catch (error) {
// // //       console.error('Error fetching disbursement details:', error);
// // //       toast.error('Failed to load payment details');
// // //     } finally {
// // //       setDetailLoading(false);
// // //     }
// // //   };

// // //   const handleViewDetails = (disbursement) => {
// // //     setSelectedDisbursement(disbursement);
// // //     setShowDetailModal(true);
// // //     fetchDisbursementDetail(disbursement.id);
// // //   };

// // //   const handleCloseDetailModal = () => {
// // //     setShowDetailModal(false);
// // //     setSelectedDisbursement(null);
// // //     setDisbursementDetail(null);
// // //   };

// // //   const filteredDisbursements = disbursements.filter(disb => {
// // //     // Search filter
// // //     if (filters.search) {
// // //       const search = filters.search.toLowerCase();
// // //       return (
// // //         disb.transaction_reference?.toLowerCase().includes(search) ||
// // //         disb.payout?.project_name?.toLowerCase().includes(search) ||
// // //         disb.payout?.artisan_name?.toLowerCase().includes(search) ||
// // //         disb.id?.toString().includes(search)
// // //       );
// // //     }
    
// // //     // Payment method filter
// // //     if (filters.payment_method !== 'all' && disb.payment_method !== filters.payment_method) {
// // //       return false;
// // //     }
    
// // //     return true;
// // //   });

// // //   const getPaymentMethodIcon = (method) => {
// // //     if (method === 'mpesa') return '📱';
// // //     if (method === 'bank') return '🏦';
// // //     return '💰';
// // //   };

// // //   const getPaymentMethodLabel = (method) => {
// // //     if (method === 'mpesa') return 'M-Pesa';
// // //     if (method === 'bank') return 'Bank Transfer';
// // //     return method || 'N/A';
// // //   };

// // //   const formatCurrency = (amount) => {
// // //     if (amount === undefined || amount === null) return 'KES 0.00';
// // //     return new Intl.NumberFormat('en-KE', {
// // //       style: 'currency',
// // //       currency: 'KES',
// // //       minimumFractionDigits: 2,
// // //     }).format(parseFloat(amount));
// // //   };

// // //   const formatDate = (date) => {
// // //     if (!date) return 'N/A';
// // //     try {
// // //       return new Date(date).toLocaleDateString('en-KE', {
// // //         year: 'numeric',
// // //         month: 'short',
// // //         day: 'numeric',
// // //         hour: '2-digit',
// // //         minute: '2-digit',
// // //       });
// // //     } catch {
// // //       return 'N/A';
// // //     }
// // //   };

// // //   const formatDateShort = (date) => {
// // //     if (!date) return 'N/A';
// // //     try {
// // //       return new Date(date).toLocaleDateString('en-KE', {
// // //         year: 'numeric',
// // //         month: 'short',
// // //         day: 'numeric',
// // //       });
// // //     } catch {
// // //       return 'N/A';
// // //     }
// // //   };

// // //   if (loading) {
// // //     return (
// // //       <div className="artisan-disbursements">
// // //         <div className="loading-container">
// // //           <div className="loading-spinner"></div>
// // //           <p>Loading your payments...</p>
// // //         </div>
// // //       </div>
// // //     );
// // //   }

// // //   return (
// // //    <>
// // //    <FurnitureNavbar/>
// // //     <div className="artisan-disbursements">
    

// // //       {/* Page Header */}
// // //       <div className="page-header">
// // //         <div className="header-content">
// // //           <div className="header-text">
// // //             <h1>My Payments</h1>
// // //             <p>View all your payment history and disbursements</p>
// // //           </div>
// // //           <div className="header-actions">
// // //             <button className="btn btn-refresh" onClick={fetchDisbursements}>
// // //               Refresh
// // //             </button>
// // //           </div>
// // //         </div>
// // //       </div>

// // //       {/* Stats Cards */}
// // //       <div className="stats-overview">
// // //         <div className="stat-card total">
// // //           <div className="stat-icon">
// // //             <FaMoneyBillWave />
// // //           </div>
// // //           <div className="stat-info">
// // //             <h3>Total Payments</h3>
// // //             <p className="stat-value">{stats.total}</p>
// // //           </div>
// // //         </div>
// // //         <div className="stat-card amount">
// // //           <div className="stat-icon">
// // //             <FaWallet />
// // //           </div>
// // //           <div className="stat-info">
// // //             <h3>Total Amount Received</h3>
// // //             <p className="stat-value">{formatCurrency(stats.total_amount)}</p>
// // //           </div>
// // //         </div>
// // //         <div className="stat-card mpesa">
// // //           <div className="stat-icon">📱</div>
// // //           <div className="stat-info">
// // //             <h3>M-Pesa Payments</h3>
// // //             <p className="stat-value">{stats.mpesa_count}</p>
// // //           </div>
// // //         </div>
// // //         <div className="stat-card bank">
// // //           <div className="stat-icon">🏦</div>
// // //           <div className="stat-info">
// // //             <h3>Bank Transfers</h3>
// // //             <p className="stat-value">{stats.bank_count}</p>
// // //           </div>
// // //         </div>
// // //       </div>

// // //       {/* Filters */}
// // //       <div className="filters-section">
// // //         <div className="filters-bar">
// // //           <div className="search-box">
// // //             <FaSearch className="search-icon" />
// // //             <input
// // //               type="text"
// // //               placeholder="Search by transaction, project, or ID..."
// // //               value={filters.search}
// // //               onChange={(e) => setFilters(prev => ({ ...prev, search: e.target.value }))}
// // //             />
// // //           </div>

// // //           <div className="filter-group">
// // //             <select
// // //               value={filters.payment_method}
// // //               onChange={(e) => setFilters(prev => ({ ...prev, payment_method: e.target.value }))}
// // //             >
// // //               <option value="all">All Methods</option>
// // //               <option value="mpesa">📱 M-Pesa</option>
// // //               <option value="bank">🏦 Bank Transfer</option>
// // //             </select>
// // //           </div>

// // //           <div className="filter-actions">
// // //             <span className="results-count">
// // //               {filteredDisbursements.length} of {disbursements.length} payments
// // //             </span>
// // //           </div>
// // //         </div>
// // //       </div>

// // //       {/* Disbursements List */}
// // //       <div className="disbursements-section">
// // //         <div className="disbursements-container">
// // //           {filteredDisbursements.length === 0 ? (
// // //             <div className="empty-state">
// // //               <div className="empty-icon">💰</div>
// // //               <h3>No payments found</h3>
// // //               <p>
// // //                 You haven't received any payments yet, or no payments match your current search.
// // //               </p>
// // //             </div>
// // //           ) : (
// // //             <div className="disbursements-grid">
// // //               {filteredDisbursements.map((disb) => (
// // //                 <div key={disb.id} className="disbursement-card">
// // //                   <div className="card-header">
// // //                     <div className="card-amount">
// // //                       <span className="amount">{formatCurrency(disb.amount)}</span>
// // //                       <span className={`method-badge ${disb.payment_method}`}>
// // //                         {getPaymentMethodIcon(disb.payment_method)}{' '}
// // //                         {getPaymentMethodLabel(disb.payment_method)}
// // //                       </span>
// // //                     </div>
// // //                     <span className="card-date">{formatDateShort(disb.disbursed_at)}</span>
// // //                   </div>

// // //                   <div className="card-body">
// // //                     <div className="project-info">
// // //                       <FaProjectDiagram className="info-icon" />
// // //                       <span className="project-name">
// // //                         {disb.project_name || 'N/A'}
// // //                       </span>
// // //                       <span className="project-id">
// // //                         #{disb.project_id || 'N/A'}
// // //                       </span>
// // //                     </div>
// // //                     <div className="reference-info">
// // //                       <FaReceipt className="info-icon" />
// // //                       <span className="reference">{disb.transaction_reference || 'N/A'}</span>
// // //                     </div>
// // //                     {disb.notes && (
// // //                       <div className="notes-info">
// // //                         <span className="notes-label">📝</span>
// // //                         <span className="notes-text">{disb.notes}</span>
// // //                       </div>
// // //                     )}
// // //                   </div>

// // //                   <div className="card-footer">
// // //                     <button
// // //                       className="btn btn-view"
// // //                       onClick={() => handleViewDetails(disb)}
// // //                     >
// // //                       <FaEye /> View Details
// // //                     </button>
// // //                   </div>
// // //                 </div>
// // //               ))}
// // //             </div>
// // //           )}
// // //         </div>

// // //         {filteredDisbursements.length > 0 && (
// // //           <div className="list-footer">
// // //             <div className="footer-info">
// // //               Showing {filteredDisbursements.length} of {disbursements.length} payments
// // //             </div>
// // //           </div>
// // //         )}
// // //       </div>


// // //         {/* Detail Modal */}
// // //       {showDetailModal && selectedDisbursement && (
// // //         <div className="modal-overlay" onClick={handleCloseDetailModal}>
// // //           <div className="modal-content detail-modal" onClick={e => e.stopPropagation()}>
// // //             <div className="modal-header">
// // //               <div className="modal-title">
// // //                 <FaReceipt className="modal-icon" />
// // //                 <div>
// // //                   <h2>Payment Details</h2>
// // //                   <p>Transaction #{selectedDisbursement.id}</p>
// // //                 </div>
// // //               </div>
// // //               <button className="close-modal" onClick={handleCloseDetailModal}>
// // //                 <FaTimes />
// // //               </button>
// // //             </div>

// // //             {detailLoading ? (
// // //               <div className="detail-loading">
// // //                 <div className="loading-spinner-small"></div>
// // //                 <p>Loading details...</p>
// // //               </div>
// // //             ) : disbursementDetail ? (
// // //               <div className="detail-content">
// // //                 {/* Payment Summary */}
// // //                 <div className="detail-summary-card">
// // //                   <div className="summary-amount">
// // //                     <span className="amount-label">Amount Received</span>
// // //                     <span className="amount-value">{formatCurrency(disbursementDetail.amount)}</span>
// // //                   </div>
// // //                   <div className="summary-method">
// // //                     <span className="method-icon">
// // //                       {getPaymentMethodIcon(disbursementDetail.payment_method)}
// // //                     </span>
// // //                     <span className="method-label">
// // //                       {getPaymentMethodLabel(disbursementDetail.payment_method)}
// // //                     </span>
// // //                   </div>
// // //                 </div>

// // //                 {/* Project Info */}
// // //                 <div className="detail-section">
// // //                   <h3 className="section-title">
// // //                     <FaProjectDiagram /> Project Information
// // //                   </h3>
// // //                   <div className="detail-grid">
// // //                     <div className="detail-item">
// // //                       <span className="label">Project Name</span>
// // //                       <span className="value">
// // //                         {disbursementDetail.project_name || 'N/A'}
// // //                       </span>
// // //                     </div>
// // //                     <div className="detail-item">
// // //                       <span className="label">Project ID</span>
// // //                       <span className="value">
// // //                         #{disbursementDetail.project_id || 'N/A'}
// // //                       </span>
// // //                     </div>
// // //                     <div className="detail-item">
// // //                       <span className="label">Payout Stage</span>
// // //                       <span className="value stage-badge">
// // //                         {disbursementDetail.payout_stage || 'N/A'}
// // //                       </span>
// // //                     </div>
                    
// // //                   </div>
// // //                 </div>

// // //                 {/* Transaction Details */}
// // //                 <div className="detail-section">
// // //                   <h3 className="section-title">
// // //                     <FaWallet /> Transaction Details
// // //                   </h3>
// // //                   <div className="detail-grid">
// // //                     <div className="detail-item">
// // //                       <span className="label">Transaction Reference</span>
// // //                       <span className="value highlight-ref">
// // //                         {disbursementDetail.transaction_reference || 'N/A'}
// // //                       </span>
// // //                     </div>
// // //                     <div className="detail-item">
// // //                       <span className="label">Payment Method</span>
// // //                       <span className="value">
// // //                         <span className={`method-badge ${disbursementDetail.payment_method}`}>
// // //                           {getPaymentMethodIcon(disbursementDetail.payment_method)}{' '}
// // //                           {getPaymentMethodLabel(disbursementDetail.payment_method)}
// // //                         </span>
// // //                       </span>
// // //                     </div>
                    
// // //                     <div className="detail-item">
// // //                       <span className="label">Disbursed At</span>
// // //                       <span className="value">{formatDate(disbursementDetail.created_at)}</span>
// // //                     </div>
// // //                   </div>
// // //                 </div>

              
                
// // //               </div>
// // //             ) : (
// // //               <div className="detail-error">
// // //                 <p>Failed to load payment details.</p>
// // //               </div>
// // //             )}

// // //             <div className="modal-footer">
// // //               <button className="btn btn-secondary" onClick={handleCloseDetailModal}>
// // //                 Close
// // //               </button>
// // //             </div>
// // //           </div>
// // //         </div>
// // //       )}
// // //     </div>
// // //    </>
// // //   );
// // // };

// // // export default withAuth(ArtisanDisbursements, 'artisan');



// // // pages/ArtisanDisbursements.jsx
// // import React, { useState, useEffect } from 'react';
// // import { 
// //   FaSearch,
// //   FaMoneyBillWave,
// //   FaClock,
// //   FaCheckCircle,
// //   FaEye,
// //   FaTimes,
// //   FaUser,
// //   FaProjectDiagram,
// //   FaCalendarAlt,
// //   FaReceipt,
// //   FaWallet,
// //   FaArrowRight,
// //   FaChevronDown,
// //   FaChevronUp,
// // } from 'react-icons/fa';
// // import withAuth from '../../auth/WithAuth';
// // import { toast } from 'react-toastify';
// // import './payments.scss';
// // import { serverUrlAuth } from '../../../serverUrl';
// // import FurnitureNavbar from '../../../components/layout/Nav';

// // const ArtisanDisbursements = () => {
// //   const [disbursements, setDisbursements] = useState([]);
// //   const [groupedDisbursements, setGroupedDisbursements] = useState([]);
// //   const [loading, setLoading] = useState(true);
// //   const [showDetailModal, setShowDetailModal] = useState(false);
// //   const [selectedDisbursement, setSelectedDisbursement] = useState(null);
// //   const [disbursementDetail, setDisbursementDetail] = useState(null);
// //   const [detailLoading, setDetailLoading] = useState(false);
// //   const [expandedProjects, setExpandedProjects] = useState({});
// //   const [filters, setFilters] = useState({
// //     search: '',
// //     payment_method: 'all',
// //   });

// //   // Stats
// //   const [stats, setStats] = useState({
// //     total: 0,
// //     total_amount: 0,
// //     mpesa_count: 0,
// //     bank_count: 0,
// //     projects_count: 0,
// //   });

// //   useEffect(() => {
// //     fetchDisbursements();
// //   }, []);

// //   const fetchDisbursements = async () => {
// //     setLoading(true);
// //     try {
// //       const response = await serverUrlAuth.get('disbursement/my-disbursements/');
      
// //       let data = response.data;
// //       let disbursementsList = [];
      
// //       // Handle nested data structure
// //       if (data.disbursements && Array.isArray(data.disbursements)) {
// //         disbursementsList = data.disbursements;
// //       } else if (Array.isArray(data)) {
// //         disbursementsList = data;
// //       } else if (data.results && Array.isArray(data.results)) {
// //         disbursementsList = data.results;
// //       }
      
// //       setDisbursements(disbursementsList);
      
// //       // Group disbursements by payout/project
// //       const grouped = groupDisbursementsByProject(disbursementsList);
// //       setGroupedDisbursements(grouped);
      
// //       // Auto-expand projects with pending/partially paid status
// //       const initialExpanded = {};
// //       grouped.forEach(group => {
// //         if (group.status === 'pending' || group.status === 'partially_paid') {
// //           initialExpanded[group.payout_id] = true;
// //         }
// //       });
// //       setExpandedProjects(initialExpanded);
      
// //       updateStats(disbursementsList);
// //     } catch (error) {
// //       console.error('Error fetching disbursements:', error);
// //       toast.error('Failed to load payment history');
// //       setDisbursements([]);
// //       setGroupedDisbursements([]);
// //     } finally {
// //       setLoading(false);
// //     }
// //   };

// //   const groupDisbursementsByProject = (disbursementsList) => {
// //     const groups = {};
    
// //     disbursementsList.forEach(disb => {
// //       const key = disb.payout || disb.payout_id || 'unknown';
      
// //       if (!groups[key]) {
// //         groups[key] = {
// //           payout_id: key,
// //           project_name: disb.project_name || 'Unknown Project',
// //           project_id: disb.project_id || 'N/A',
// //           artisan_name: disb.artisan_name || disb.payout?.artisan_name || 'N/A',
// //           status: disb.payout_status || 'pending',
// //           total_amount: 0,
// //           total_disbursed: 0,
// //           remaining_amount: 0,
// //           disbursements: [],
// //           created_at: disb.created_at || disb.disbursed_at,
// //         };
// //       }
      
// //       // Add disbursement to group
// //       groups[key].disbursements.push(disb);
// //       groups[key].total_amount = parseFloat(disb.payout?.artisan_amount || disb.artisan_amount || 0);
// //       groups[key].total_disbursed += parseFloat(disb.amount || 0);
// //       groups[key].remaining_amount = groups[key].total_amount - groups[key].total_disbursed;
      
// //       // Update status based on disbursements
// //       const totalAmount = groups[key].total_amount;
// //       const totalDisbursed = groups[key].total_disbursed;
      
// //       if (totalDisbursed === 0) {
// //         groups[key].status = 'pending';
// //       } else if (totalDisbursed < totalAmount) {
// //         groups[key].status = 'partially_paid';
// //       } else {
// //         groups[key].status = 'paid';
// //       }
// //     });
    
// //     // Convert to array and sort by created_at (newest first)
// //     return Object.values(groups).sort((a, b) => {
// //       return new Date(b.created_at) - new Date(a.created_at);
// //     });
// //   };

// //   const updateStats = (data) => {
// //     const total = data.length;
// //     const total_amount = data.reduce((sum, d) => sum + parseFloat(d.amount || 0), 0);
// //     const mpesa_count = data.filter(d => d.payment_method === 'mpesa').length;
// //     const bank_count = data.filter(d => d.payment_method === 'bank').length;
    
// //     // Count unique projects
// //     const projectIds = new Set(data.map(d => d.payout || d.payout_id));
// //     const projects_count = projectIds.size;
    
// //     setStats({ total, total_amount, mpesa_count, bank_count, projects_count });
// //   };

// //   const fetchDisbursementDetail = async (disbursementId) => {
// //     setDetailLoading(true);
// //     try {
// //       const response = await serverUrlAuth.get(`disbursement/my-disbursements/${disbursementId}/`);
      
// //       let data = response.data;
      
// //       // Handle nested data structure
// //       if (data.disbursement) {
// //         data = data.disbursement;
// //       }
      
// //       setDisbursementDetail(data);
// //     } catch (error) {
// //       console.error('Error fetching disbursement details:', error);
// //       toast.error('Failed to load payment details');
// //     } finally {
// //       setDetailLoading(false);
// //     }
// //   };

// //   const handleViewDetails = (disbursement) => {
// //     setSelectedDisbursement(disbursement);
// //     setShowDetailModal(true);
// //     fetchDisbursementDetail(disbursement.id);
// //   };

// //   const handleCloseDetailModal = () => {
// //     setShowDetailModal(false);
// //     setSelectedDisbursement(null);
// //     setDisbursementDetail(null);
// //   };

// //   const toggleProjectExpansion = (payoutId) => {
// //     setExpandedProjects(prev => ({
// //       ...prev,
// //       [payoutId]: !prev[payoutId]
// //     }));
// //   };

// //   const filteredGroupedDisbursements = groupedDisbursements.filter(group => {
// //     // Search filter
// //     if (filters.search) {
// //       const search = filters.search.toLowerCase();
// //       return (
// //         group.project_name?.toLowerCase().includes(search) ||
// //         group.payout_id?.toString().includes(search) ||
// //         group.artisan_name?.toLowerCase().includes(search)
// //       );
// //     }
// //     return true;
// //   });

// //   const getStatusConfig = (status) => {
// //     const configs = {
// //       pending: {
// //         label: 'Pending',
// //         icon: FaClock,
// //         className: 'status-pending',
// //         color: '#F59E0B',
// //         bg: '#FEF3C7',
// //       },
// //       partially_paid: {
// //         label: 'Partially Paid',
// //         icon: FaClock,
// //         className: 'status-partial',
// //         color: '#3B82F6',
// //         bg: '#DBEAFE',
// //       },
// //       paid: {
// //         label: 'Fully Paid',
// //         icon: FaCheckCircle,
// //         className: 'status-paid',
// //         color: '#10B981',
// //         bg: '#D1FAE5',
// //       },
// //     };
// //     return configs[status] || configs.pending;
// //   };

// //   const getPaymentMethodIcon = (method) => {
// //     if (method === 'mpesa') return '📱';
// //     if (method === 'bank') return '🏦';
// //     return '💰';
// //   };

// //   const getPaymentMethodLabel = (method) => {
// //     if (method === 'mpesa') return 'M-Pesa';
// //     if (method === 'bank') return 'Bank Transfer';
// //     return method || 'N/A';
// //   };

// //   const formatCurrency = (amount) => {
// //     if (amount === undefined || amount === null) return 'KES 0.00';
// //     return new Intl.NumberFormat('en-KE', {
// //       style: 'currency',
// //       currency: 'KES',
// //       minimumFractionDigits: 2,
// //     }).format(parseFloat(amount));
// //   };

// //   const formatDate = (date) => {
// //     if (!date) return 'N/A';
// //     try {
// //       return new Date(date).toLocaleDateString('en-KE', {
// //         year: 'numeric',
// //         month: 'short',
// //         day: 'numeric',
// //         hour: '2-digit',
// //         minute: '2-digit',
// //       });
// //     } catch {
// //       return 'N/A';
// //     }
// //   };

// //   const formatDateShort = (date) => {
// //     if (!date) return 'N/A';
// //     try {
// //       return new Date(date).toLocaleDateString('en-KE', {
// //         year: 'numeric',
// //         month: 'short',
// //         day: 'numeric',
// //       });
// //     } catch {
// //       return 'N/A';
// //     }
// //   };

// //   if (loading) {
// //     return (
// //       <>
// //         <FurnitureNavbar />
// //         <div className="artisan-disbursements">
// //           <div className="loading-container">
// //             <div className="loading-spinner"></div>
// //             <p>Loading your payments...</p>
// //           </div>
// //         </div>
// //       </>
// //     );
// //   }

// //   return (
// //     <>
// //       <FurnitureNavbar />
// //       <div className="artisan-disbursements">
// //         {/* Page Header */}
// //         <div className="page-header">
// //           <div className="header-content">
// //             <div className="header-text">
// //               <h1>My Payments</h1>
// //               <p>View all your payment history grouped by project</p>
// //             </div>
// //             <div className="header-actions">
// //               <button className="btn btn-refresh" onClick={fetchDisbursements}>
// //                 Refresh
// //               </button>
// //             </div>
// //           </div>
// //         </div>

// //         {/* Stats Cards */}
// //         <div className="stats-overview">
// //           <div className="stat-card total">
// //             <div className="stat-icon">
// //               <FaProjectDiagram />
// //             </div>
// //             <div className="stat-info">
// //               <h3>Total Projects</h3>
// //               <p className="stat-value">{stats.projects_count}</p>
// //             </div>
// //           </div>
// //           <div className="stat-card amount">
// //             <div className="stat-icon">
// //               <FaWallet />
// //             </div>
// //             <div className="stat-info">
// //               <h3>Total Received</h3>
// //               <p className="stat-value">{formatCurrency(stats.total_amount)}</p>
// //             </div>
// //           </div>
// //           <div className="stat-card mpesa">
// //             <div className="stat-icon">📱</div>
// //             <div className="stat-info">
// //               <h3>M-Pesa Payments</h3>
// //               <p className="stat-value">{stats.mpesa_count}</p>
// //             </div>
// //           </div>
// //           <div className="stat-card bank">
// //             <div className="stat-icon">🏦</div>
// //             <div className="stat-info">
// //               <h3>Bank Transfers</h3>
// //               <p className="stat-value">{stats.bank_count}</p>
// //             </div>
// //           </div>
// //         </div>

// //         {/* Filters */}
// //         <div className="filters-section">
// //           <div className="filters-bar">
// //             <div className="search-box">
// //               <FaSearch className="search-icon" />
// //               <input
// //                 type="text"
// //                 placeholder="Search by project name or ID..."
// //                 value={filters.search}
// //                 onChange={(e) => setFilters(prev => ({ ...prev, search: e.target.value }))}
// //               />
// //             </div>

// //             <div className="filter-actions">
// //               <span className="results-count">
// //                 {filteredGroupedDisbursements.length} of {groupedDisbursements.length} projects
// //               </span>
// //             </div>
// //           </div>
// //         </div>

// //         {/* Grouped Disbursements List */}
// //         <div className="disbursements-section">
// //           <div className="disbursements-container">
// //             {filteredGroupedDisbursements.length === 0 ? (
// //               <div className="empty-state">
// //                 <div className="empty-icon">💰</div>
// //                 <h3>No payments found</h3>
// //                 <p>
// //                   You haven't received any payments yet, or no projects match your current search.
// //                 </p>
// //               </div>
// //             ) : (
// //               <div className="project-groups">
// //                 {filteredGroupedDisbursements.map((group) => {
// //                   const statusConfig = getStatusConfig(group.status);
// //                   const StatusIcon = statusConfig.icon;
// //                   const isExpanded = expandedProjects[group.payout_id] || false;
// //                   const totalDisbursements = group.disbursements.length;

// //                   return (
// //                     <div key={group.payout_id} className="project-group-card">
// //                       {/* Project Header */}
// //                       <div 
// //                         className="project-header"
// //                         onClick={() => toggleProjectExpansion(group.payout_id)}
// //                       >
// //                         <div className="project-header-left">
// //                           <div className="project-icon">
// //                             <FaProjectDiagram />
// //                           </div>
// //                           <div className="project-info">
// //                             <h3 className="project-name">{group.project_name}</h3>
// //                             <div className="project-meta">
// //                               <span className="project-id">Project #{group.project_id}</span>
// //                               <span className="project-payments-count">
// //                                 {totalDisbursements} payment{totalDisbursements !== 1 ? 's' : ''}
// //                               </span>
// //                             </div>
// //                           </div>
// //                         </div>
// //                         <div className="project-header-right">
// //                           <div className="project-amounts">
// //                             <div className="amount-disbursed">
// //                               <span className="label">Paid</span>
// //                               <span className="value">{formatCurrency(group.total_disbursed)}</span>
// //                             </div>
// //                             <div className="amount-total">
// //                               <span className="label">Total</span>
// //                               <span className="value">{formatCurrency(group.total_amount)}</span>
// //                             </div>
// //                             {group.remaining_amount > 0 && (
// //                               <div className="amount-remaining">
// //                                 <span className="label">Remaining</span>
// //                                 <span className="value">{formatCurrency(group.remaining_amount)}</span>
// //                               </div>
// //                             )}
// //                           </div>
// //                           <div className="project-status">
// //                             <span className={`status-badge ${statusConfig.className}`}>
// //                               <StatusIcon /> {statusConfig.label}
// //                             </span>
// //                           </div>
// //                           <div className="expand-icon">
// //                             {isExpanded ? <FaChevronUp /> : <FaChevronDown />}
// //                           </div>
// //                         </div>
// //                       </div>

// //                       {/* Disbursement List (Expandable) */}
// //                       {isExpanded && (
// //                         <div className="disbursement-list">
// //                           {group.disbursements.map((disb, index) => (
// //                             <div key={disb.id} className="disbursement-item">
// //                               <div className="disbursement-index">#{index + 1}</div>
// //                               <div className="disbursement-details">
// //                                 <div className="disb-amount">
// //                                   <span className="amount">{formatCurrency(disb.amount)}</span>
// //                                   <span className={`method-badge ${disb.payment_method}`}>
// //                                     {getPaymentMethodIcon(disb.payment_method)}{' '}
// //                                     {getPaymentMethodLabel(disb.payment_method)}
// //                                   </span>
// //                                 </div>
// //                                 <div className="disb-info">
// //                                   <span className="disb-reference">
// //                                     <FaReceipt className="info-icon" />
// //                                     {disb.transaction_reference || 'N/A'}
// //                                   </span>
// //                                   <span className="disb-date">
// //                                     <FaCalendarAlt className="info-icon" />
// //                                     {formatDateShort(disb.disbursed_at)}
// //                                   </span>
// //                                   {disb.notes && (
// //                                     <span className="disb-notes">
// //                                       📝 {disb.notes}
// //                                     </span>
// //                                   )}
// //                                 </div>
// //                               </div>
// //                               <div className="disbursement-actions">
// //                                 <button
// //                                   className="btn btn-sm btn-view"
// //                                   onClick={(e) => {
// //                                     e.stopPropagation();
// //                                     handleViewDetails(disb);
// //                                   }}
// //                                 >
// //                                   <FaEye /> View
// //                                 </button>
// //                               </div>
// //                             </div>
// //                           ))}
// //                         </div>
// //                       )}
// //                     </div>
// //                   );
// //                 })}
// //               </div>
// //             )}
// //           </div>
// //         </div>

// //         {/* Detail Modal */}
// //         {showDetailModal && selectedDisbursement && (
// //           <div className="modal-overlay" onClick={handleCloseDetailModal}>
// //             <div className="modal-content detail-modal" onClick={e => e.stopPropagation()}>
// //               <div className="modal-header">
// //                 <div className="modal-title">
// //                   <FaReceipt className="modal-icon" />
// //                   <div>
// //                     <h2>Payment Details</h2>
// //                     <p>Transaction #{selectedDisbursement.id}</p>
// //                   </div>
// //                 </div>
// //                 <button className="close-modal" onClick={handleCloseDetailModal}>
// //                   <FaTimes />
// //                 </button>
// //               </div>

// //               {detailLoading ? (
// //                 <div className="detail-loading">
// //                   <div className="loading-spinner-small"></div>
// //                   <p>Loading details...</p>
// //                 </div>
// //               ) : disbursementDetail ? (
// //                 <div className="detail-content">
// //                   {/* Payment Summary */}
// //                   <div className="detail-summary-card">
// //                     <div className="summary-amount">
// //                       <span className="amount-label">Amount Received</span>
// //                       <span className="amount-value">{formatCurrency(disbursementDetail.amount)}</span>
// //                     </div>
// //                     <div className="summary-method">
// //                       <span className="method-icon">
// //                         {getPaymentMethodIcon(disbursementDetail.payment_method)}
// //                       </span>
// //                       <span className="method-label">
// //                         {getPaymentMethodLabel(disbursementDetail.payment_method)}
// //                       </span>
// //                     </div>
// //                   </div>

// //                   {/* Project Info */}
// //                   <div className="detail-section">
// //                     <h3 className="section-title">
// //                       <FaProjectDiagram /> Project Information
// //                     </h3>
// //                     <div className="detail-grid">
// //                       <div className="detail-item">
// //                         <span className="label">Project Name</span>
// //                         <span className="value">
// //                           {disbursementDetail.project_name || 'N/A'}
// //                         </span>
// //                       </div>
// //                       <div className="detail-item">
// //                         <span className="label">Project ID</span>
// //                         <span className="value">
// //                           #{disbursementDetail.project_id || 'N/A'}
// //                         </span>
// //                       </div>
// //                       <div className="detail-item">
// //                         <span className="label">Payout Stage</span>
// //                         <span className="value stage-badge">
// //                           {disbursementDetail.payout_stage || 'N/A'}
// //                         </span>
// //                       </div>
// //                     </div>
// //                   </div>

// //                   {/* Transaction Details */}
// //                   <div className="detail-section">
// //                     <h3 className="section-title">
// //                       <FaWallet /> Transaction Details
// //                     </h3>
// //                     <div className="detail-grid">
// //                       <div className="detail-item">
// //                         <span className="label">Transaction Reference</span>
// //                         <span className="value highlight-ref">
// //                           {disbursementDetail.transaction_reference || 'N/A'}
// //                         </span>
// //                       </div>
// //                       <div className="detail-item">
// //                         <span className="label">Payment Method</span>
// //                         <span className="value">
// //                           <span className={`method-badge ${disbursementDetail.payment_method}`}>
// //                             {getPaymentMethodIcon(disbursementDetail.payment_method)}{' '}
// //                             {getPaymentMethodLabel(disbursementDetail.payment_method)}
// //                           </span>
// //                         </span>
// //                       </div>
// //                       <div className="detail-item">
// //                         <span className="label">Disbursed At</span>
// //                         <span className="value">{formatDate(disbursementDetail.created_at)}</span>
// //                       </div>
// //                     </div>
// //                   </div>
// //                 </div>
// //               ) : (
// //                 <div className="detail-error">
// //                   <p>Failed to load payment details.</p>
// //                 </div>
// //               )}

// //               <div className="modal-footer">
// //                 <button className="btn btn-secondary" onClick={handleCloseDetailModal}>
// //                   Close
// //                 </button>
// //               </div>
// //             </div>
// //           </div>
// //         )}
// //       </div>
// //     </>
// //   );
// // };

// // export default withAuth(ArtisanDisbursements, 'artisan');



// // pages/ArtisanDisbursements.jsx
// import React, { useState, useEffect } from 'react';
// import { 
//   FaSearch,
//   FaMoneyBillWave,
//   FaClock,
//   FaCheckCircle,
//   FaEye,
//   FaTimes,
//   FaUser,
//   FaProjectDiagram,
//   FaCalendarAlt,
//   FaReceipt,
//   FaWallet,
//   FaArrowRight,
//   FaChevronDown,
//   FaChevronUp,
//   FaExclamationCircle,
// } from 'react-icons/fa';
// import withAuth from '../../auth/WithAuth';
// import { toast } from 'react-toastify';
// import './payments.scss';
// import { serverUrlAuth } from '../../../serverUrl';
// import FurnitureNavbar from '../../../components/layout/Nav';

// const ArtisanDisbursements = () => {
//   const [payouts, setPayouts] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [showDetailModal, setShowDetailModal] = useState(false);
//   const [selectedDisbursement, setSelectedDisbursement] = useState(null);
//   const [disbursementDetail, setDisbursementDetail] = useState(null);
//   const [detailLoading, setDetailLoading] = useState(false);
//   const [expandedProjects, setExpandedProjects] = useState({});
//   const [filters, setFilters] = useState({
//     search: '',
//   });

//   // Stats
//   const [stats, setStats] = useState({
//     total_payouts: 0,
//     total_amount: 0,
//     total_disbursed: 0,
//     pending_count: 0,
//     partially_paid_count: 0,
//     paid_count: 0,
//   });

//   useEffect(() => {
//     fetchPayouts();
//   }, []);

//   const fetchPayouts = async () => {
//     setLoading(true);
//     try {
//       const response = await serverUrlAuth.get('disbursement/my-payouts/');
      
//       let data = response.data;
//       let payoutsList = [];
      
//       // Handle new data structure
//       if (data.payouts && Array.isArray(data.payouts)) {
//         payoutsList = data.payouts;
//       } else if (data.disbursements && Array.isArray(data.disbursements)) {
//         // Fallback for old structure
//         payoutsList = groupDisbursementsByPayout(data.disbursements);
//       } else if (Array.isArray(data)) {
//         payoutsList = data;
//       }
      
//       setPayouts(payoutsList);
      
//       // Auto-expand projects with pending/partially paid status
//       const initialExpanded = {};
//       payoutsList.forEach(payout => {
//         if (payout.status === 'pending' || payout.status === 'partially_paid') {
//           initialExpanded[payout.id] = true;
//         }
//       });
//       setExpandedProjects(initialExpanded);
      
//       updateStats(payoutsList);
//     } catch (error) {
//       console.error('Error fetching payouts:', error);
//       toast.error('Failed to load payment history');
//       setPayouts([]);
//     } finally {
//       setLoading(false);
//     }
//   };

//   // Fallback: Group disbursements by payout (for old API structure)
//   const groupDisbursementsByPayout = (disbursementsList) => {
//     const groups = {};
    
//     disbursementsList.forEach(disb => {
//       const key = disb.payout || disb.payout_id || 'unknown';
      
//       if (!groups[key]) {
//         groups[key] = {
//           id: key,
//           project_name: disb.project_name || 'Unknown Project',
//           project_id: disb.project_id || 'N/A',
//           artisan_name: disb.artisan_name || 'N/A',
//           status: disb.payout_status || 'pending',
//           artisan_amount: parseFloat(disb.artisan_amount || 0),
//           amount_disbursed: 0,
//           amount_remaining: 0,
//           disbursements: [],
//           created_at: disb.created_at || disb.disbursed_at,
//         };
//       }
      
//       groups[key].disbursements.push(disb);
//       groups[key].amount_disbursed += parseFloat(disb.amount || 0);
//       groups[key].amount_remaining = groups[key].artisan_amount - groups[key].amount_disbursed;
      
//       // Update status based on disbursements
//       const totalAmount = groups[key].artisan_amount;
//       const totalDisbursed = groups[key].amount_disbursed;
      
//       if (totalDisbursed === 0) {
//         groups[key].status = 'pending';
//       } else if (totalDisbursed < totalAmount) {
//         groups[key].status = 'partially_paid';
//       } else {
//         groups[key].status = 'paid';
//       }
//     });
    
//     return Object.values(groups).sort((a, b) => {
//       return new Date(b.created_at) - new Date(a.created_at);
//     });
//   };

//   const updateStats = (data) => {
//     const total_payouts = data.length;
//     const total_amount = data.reduce((sum, p) => sum + parseFloat(p.artisan_amount || 0), 0);
//     const total_disbursed = data.reduce((sum, p) => sum + parseFloat(p.amount_disbursed || 0), 0);
//     const pending_count = data.filter(p => p.status === 'pending').length;
//     const partially_paid_count = data.filter(p => p.status === 'partially_paid').length;
//     const paid_count = data.filter(p => p.status === 'paid').length;
    
//     setStats({ total_payouts, total_amount, total_disbursed, pending_count, partially_paid_count, paid_count });
//   };

//   const fetchDisbursementDetail = async (disbursementId) => {
//     setDetailLoading(true);
//     try {
//       const response = await serverUrlAuth.get(`disbursement/my-disbursements/${disbursementId}/`);
      
//       let data = response.data;
      
//       // Handle nested data structure
//       if (data.disbursement) {
//         data = data.disbursement;
//       }
      
//       setDisbursementDetail(data);
//     } catch (error) {
//       console.error('Error fetching disbursement details:', error);
//       toast.error('Failed to load payment details');
//     } finally {
//       setDetailLoading(false);
//     }
//   };

//   const handleViewDetails = (disbursement) => {
//     setSelectedDisbursement(disbursement);
//     setShowDetailModal(true);
//     fetchDisbursementDetail(disbursement.id);
//   };

//   const handleCloseDetailModal = () => {
//     setShowDetailModal(false);
//     setSelectedDisbursement(null);
//     setDisbursementDetail(null);
//   };

//   const toggleProjectExpansion = (payoutId) => {
//     setExpandedProjects(prev => ({
//       ...prev,
//       [payoutId]: !prev[payoutId]
//     }));
//   };

//   const filteredPayouts = payouts.filter(payout => {
//     // Search filter
//     if (filters.search) {
//       const search = filters.search.toLowerCase();
//       return (
//         payout.project_name?.toLowerCase().includes(search) ||
//         payout.id?.toString().includes(search) ||
//         payout.artisan_name?.toLowerCase().includes(search)
//       );
//     }
//     return true;
//   });

//   const getStatusConfig = (status) => {
//     const configs = {
//       pending: {
//         label: 'Pending',
//         icon: FaClock,
//         className: 'status-pending',
//         color: '#F59E0B',
//         bg: '#FEF3C7',
//       },
//       partially_paid: {
//         label: 'Partially Paid',
//         icon: FaExclamationCircle,
//         className: 'status-partial',
//         color: '#3B82F6',
//         bg: '#DBEAFE',
//       },
//       paid: {
//         label: 'Fully Paid',
//         icon: FaCheckCircle,
//         className: 'status-paid',
//         color: '#10B981',
//         bg: '#D1FAE5',
//       },
//     };
//     return configs[status] || configs.pending;
//   };

//   const getPaymentMethodIcon = (method) => {
//     if (method === 'mpesa') return '📱';
//     if (method === 'bank') return '🏦';
//     return '💰';
//   };

//   const getPaymentMethodLabel = (method) => {
//     if (method === 'mpesa') return 'M-Pesa';
//     if (method === 'bank') return 'Bank Transfer';
//     return method || 'N/A';
//   };

//   const getStageLabel = (stage) => {
//     const stages = {
//       'deposit': 'Deposit',
//       'deposit_initial': 'Deposit - Initial',
//       'deposit_progress': 'Deposit - Progress',
//       'balance_initial': 'Balance - Initial',
//       'balance_final': 'Balance - Final',
//     };
//     return stages[stage] || stage || 'N/A';
//   };

//   const formatCurrency = (amount) => {
//     if (amount === undefined || amount === null || isNaN(amount)) return 'KES 0.00';
//     return new Intl.NumberFormat('en-KE', {
//       style: 'currency',
//       currency: 'KES',
//       minimumFractionDigits: 2,
//     }).format(parseFloat(amount));
//   };

//   const formatDate = (date) => {
//     if (!date) return 'N/A';
//     try {
//       return new Date(date).toLocaleDateString('en-KE', {
//         year: 'numeric',
//         month: 'short',
//         day: 'numeric',
//         hour: '2-digit',
//         minute: '2-digit',
//       });
//     } catch {
//       return 'N/A';
//     }
//   };

//   const formatDateShort = (date) => {
//     if (!date) return 'N/A';
//     try {
//       return new Date(date).toLocaleDateString('en-KE', {
//         year: 'numeric',
//         month: 'short',
//         day: 'numeric',
//       });
//     } catch {
//       return 'N/A';
//     }
//   };

//   if (loading) {
//     return (
//       <>
//         <FurnitureNavbar />
//         <div className="artisan-disbursements">
//           <div className="loading-container">
//             <div className="loading-spinner"></div>
//             <p>Loading your payments...</p>
//           </div>
//         </div>
//       </>
//     );
//   }

//   return (
//     <>
//       <FurnitureNavbar />
//       <div className="artisan-disbursements">
//         {/* Page Header */}
//         <div className="page-header">
//           <div className="header-content">
//             <div className="header-text">
//               <h1>My Payments</h1>
//               <p>View all your payment history grouped by project</p>
//             </div>
//             <div className="header-actions">
//               <button className="btn btn-refresh" onClick={fetchPayouts}>
//                 Refresh
//               </button>
//             </div>
//           </div>
//         </div>

//         {/* Stats Cards */}
//         <div className="stats-overview">
//           <div className="stat-card total">
//             <div className="stat-icon">
//               <FaProjectDiagram />
//             </div>
//             <div className="stat-info">
//               <h3>Total Projects</h3>
//               <p className="stat-value">{stats.total_payouts}</p>
//             </div>
//           </div>
//           <div className="stat-card amount">
//             <div className="stat-icon">
//               <FaWallet />
//             </div>
//             <div className="stat-info">
//               <h3>Total Amount</h3>
//               <p className="stat-value">{formatCurrency(stats.total_amount)}</p>
//             </div>
//           </div>
//           <div className="stat-card amount">
//             <div className="stat-icon">
//               <FaMoneyBillWave />
//             </div>
//             <div className="stat-info">
//               <h3>Total Received</h3>
//               <p className="stat-value">{formatCurrency(stats.total_disbursed)}</p>
//             </div>
//           </div>
//           <div className="stat-card pending">
//             <div className="stat-icon">
//               <FaClock />
//             </div>
//             <div className="stat-info">
//               <h3>Pending</h3>
//               <p className="stat-value">{stats.pending_count}</p>
//             </div>
//           </div>
//           <div className="stat-card partial">
//             <div className="stat-icon">
//               <FaExclamationCircle />
//             </div>
//             <div className="stat-info">
//               <h3>Partially Paid</h3>
//               <p className="stat-value">{stats.partially_paid_count}</p>
//             </div>
//           </div>
//           <div className="stat-card paid">
//             <div className="stat-icon">
//               <FaCheckCircle />
//             </div>
//             <div className="stat-info">
//               <h3>Fully Paid</h3>
//               <p className="stat-value">{stats.paid_count}</p>
//             </div>
//           </div>
//         </div>

//         {/* Filters */}
//         <div className="filters-section">
//           <div className="filters-bar">
//             <div className="search-box">
//               <FaSearch className="search-icon" />
//               <input
//                 type="text"
//                 placeholder="Search by project name or ID..."
//                 value={filters.search}
//                 onChange={(e) => setFilters(prev => ({ ...prev, search: e.target.value }))}
//               />
//             </div>

//             <div className="filter-actions">
//               <span className="results-count">
//                 {filteredPayouts.length} of {payouts.length} projects
//               </span>
//             </div>
//           </div>
//         </div>

//         {/* Grouped Payouts List */}
//         <div className="disbursements-section">
//           <div className="disbursements-container">
//             {filteredPayouts.length === 0 ? (
//               <div className="empty-state">
//                 <div className="empty-icon">💰</div>
//                 <h3>No payments found</h3>
//                 <p>
//                   You haven't received any payments yet, or no projects match your current search.
//                 </p>
//               </div>
//             ) : (
//               <div className="project-groups">
//                 {filteredPayouts.map((payout) => {
//                   const statusConfig = getStatusConfig(payout.status);
//                   const StatusIcon = statusConfig.icon;
//                   const isExpanded = expandedProjects[payout.id] || false;
//                   const totalDisbursements = payout.disbursements?.length || 0;
//                   const remaining = parseFloat(payout.amount_remaining) || 0;

//                   return (
//                     <div key={payout.id} className="project-group-card">
//                       {/* Project Header */}
//                       <div 
//                         className="project-header"
//                         onClick={() => toggleProjectExpansion(payout.id)}
//                       >
//                         <div className="project-header-left">
//                           <div className="project-icon">
//                             <FaProjectDiagram />
//                           </div>
//                           <div className="project-info">
//                             <h3 className="project-name">{payout.project_name}</h3>
//                             <div className="project-meta">
//                               <span className="project-id">Project #{payout.project_id}</span>
//                               <span className="project-stage">
//                                 {getStageLabel(payout.payout_stage)}
//                               </span>
//                               <span className="project-payments-count">
//                                 {totalDisbursements} payment{totalDisbursements !== 1 ? 's' : ''}
//                               </span>
//                             </div>
//                           </div>
//                         </div>
//                         <div className="project-header-right">
//                           <div className="project-amounts">
//                             <div className="amount-total">
//                               <span className="label">Total</span>
//                               <span className="value">{formatCurrency(payout.artisan_amount)}</span>
//                             </div>
//                             <div className="amount-disbursed">
//                               <span className="label">Received</span>
//                               <span className="value">{formatCurrency(payout.amount_disbursed)}</span>
//                             </div>
//                             {remaining > 0 && (
//                               <div className="amount-remaining">
//                                 <span className="label">Pending</span>
//                                 <span className="value">{formatCurrency(remaining)}</span>
//                               </div>
//                             )}
//                           </div>
//                           <div className="project-status">
//                             <span className={`status-badge ${statusConfig.className}`}>
//                               <StatusIcon /> {statusConfig.label}
//                             </span>
//                           </div>
//                           <div className="expand-icon">
//                             {isExpanded ? <FaChevronUp /> : <FaChevronDown />}
//                           </div>
//                         </div>
//                       </div>

//                       {/* Disbursement List (Expandable) */}
//                       {isExpanded && payout.disbursements && payout.disbursements.length > 0 && (
//                         <div className="disbursement-list">
//                           {payout.disbursements.map((disb, index) => (
//                             <div key={disb.id} className="disbursement-item">
//                               <div className="disbursement-index">#{index + 1}</div>
//                               <div className="disbursement-details">
//                                 <div className="disb-amount">
//                                   <span className="amount">{formatCurrency(disb.amount)}</span>
//                                   <span className={`method-badge ${disb.payment_method}`}>
//                                     {getPaymentMethodIcon(disb.payment_method)}{' '}
//                                     {getPaymentMethodLabel(disb.payment_method)}
//                                   </span>
//                                 </div>
//                                 <div className="disb-info">
//                                   <span className="disb-reference">
//                                     <FaReceipt className="info-icon" />
//                                     {disb.transaction_reference || 'N/A'}
//                                   </span>
//                                   <span className="disb-date">
//                                     <FaCalendarAlt className="info-icon" />
//                                     {formatDateShort(disb.disbursed_at)}
//                                   </span>
//                                   {disb.notes && (
//                                     <span className="disb-notes">
//                                       📝 {disb.notes}
//                                     </span>
//                                   )}
//                                 </div>
//                               </div>
//                               <div className="disbursement-actions">
//                                 <button
//                                   className="btn btn-sm btn-view"
//                                   onClick={(e) => {
//                                     e.stopPropagation();
//                                     handleViewDetails(disb);
//                                   }}
//                                 >
//                                   <FaEye /> View
//                                 </button>
//                               </div>
//                             </div>
//                           ))}
//                         </div>
//                       )}

//                       {/* No disbursements message */}
//                       {isExpanded && (!payout.disbursements || payout.disbursements.length === 0) && (
//                         <div className="disbursement-list empty">
//                           <div className="empty-disbursements">
//                             <p>No disbursements recorded yet.</p>
//                           </div>
//                         </div>
//                       )}
//                     </div>
//                   );
//                 })}
//               </div>
//             )}
//           </div>
//         </div>

//         {/* Detail Modal */}
//         {showDetailModal && selectedDisbursement && (
//           <div className="modal-overlay" onClick={handleCloseDetailModal}>
//             <div className="modal-content detail-modal" onClick={e => e.stopPropagation()}>
//               <div className="modal-header">
//                 <div className="modal-title">
//                   <FaReceipt className="modal-icon" />
//                   <div>
//                     <h2>Payment Details</h2>
//                     <p>Transaction #{selectedDisbursement.id}</p>
//                   </div>
//                 </div>
//                 <button className="close-modal" onClick={handleCloseDetailModal}>
//                   <FaTimes />
//                 </button>
//               </div>

//               {detailLoading ? (
//                 <div className="detail-loading">
//                   <div className="loading-spinner-small"></div>
//                   <p>Loading details...</p>
//                 </div>
//               ) : disbursementDetail ? (
//                 <div className="detail-content">
//                   {/* Payment Summary */}
//                   <div className="detail-summary-card">
//                     <div className="summary-amount">
//                       <span className="amount-label">Amount Received</span>
//                       <span className="amount-value">{formatCurrency(disbursementDetail.amount)}</span>
//                     </div>
//                     <div className="summary-method">
//                       <span className="method-icon">
//                         {getPaymentMethodIcon(disbursementDetail.payment_method)}
//                       </span>
//                       <span className="method-label">
//                         {getPaymentMethodLabel(disbursementDetail.payment_method)}
//                       </span>
//                     </div>
//                   </div>

//                   {/* Project Info */}
//                   <div className="detail-section">
//                     <h3 className="section-title">
//                       <FaProjectDiagram /> Project Information
//                     </h3>
//                     <div className="detail-grid">
//                       <div className="detail-item">
//                         <span className="label">Project Name</span>
//                         <span className="value">
//                           {disbursementDetail.project_name || 'N/A'}
//                         </span>
//                       </div>
//                       <div className="detail-item">
//                         <span className="label">Project ID</span>
//                         <span className="value">
//                           #{disbursementDetail.project_id || 'N/A'}
//                         </span>
//                       </div>
//                       <div className="detail-item">
//                         <span className="label">Payout Stage</span>
//                         <span className="value stage-badge">
//                           {getStageLabel(disbursementDetail.payout_stage)}
//                         </span>
//                       </div>
//                       <div className="detail-item">
//                         <span className="label">Total Payout Amount</span>
//                         <span className="value highlight-amount">
//                           {formatCurrency(disbursementDetail.artisan_amount)}
//                         </span>
//                       </div>
//                     </div>
//                   </div>

//                   {/* Transaction Details */}
//                   <div className="detail-section">
//                     <h3 className="section-title">
//                       <FaWallet /> Transaction Details
//                     </h3>
//                     <div className="detail-grid">
//                       <div className="detail-item">
//                         <span className="label">Transaction Reference</span>
//                         <span className="value highlight-ref">
//                           {disbursementDetail.transaction_reference || 'N/A'}
//                         </span>
//                       </div>
//                       <div className="detail-item">
//                         <span className="label">Payment Method</span>
//                         <span className="value">
//                           <span className={`method-badge ${disbursementDetail.payment_method}`}>
//                             {getPaymentMethodIcon(disbursementDetail.payment_method)}{' '}
//                             {getPaymentMethodLabel(disbursementDetail.payment_method)}
//                           </span>
//                         </span>
//                       </div>
//                       <div className="detail-item">
//                         <span className="label">Disbursed At</span>
//                         <span className="value">{formatDate(disbursementDetail.disbursed_at || disbursementDetail.created_at)}</span>
//                       </div>
//                       {disbursementDetail.notes && (
//                         <div className="detail-item full-width">
//                           <span className="label">Notes</span>
//                           <span className="value notes-text">{disbursementDetail.notes}</span>
//                         </div>
//                       )}
//                     </div>
//                   </div>
//                 </div>
//               ) : (
//                 <div className="detail-error">
//                   <p>Failed to load payment details.</p>
//                 </div>
//               )}

//               <div className="modal-footer">
//                 <button className="btn btn-secondary" onClick={handleCloseDetailModal}>
//                   Close
//                 </button>
//               </div>
//             </div>
//           </div>
//         )}
//       </div>
//     </>
//   );
// };

// export default withAuth(ArtisanDisbursements, 'artisan');


// pages/ArtisanDisbursements.jsx
import React, { useState, useEffect } from 'react';
import {
  FaSearch,
  FaMoneyBillWave,
  FaClock,
  FaCheckCircle,
  FaEye,
  FaTimes,
  FaUser,
  FaProjectDiagram,
  FaCalendarAlt,
  FaReceipt,
  FaWallet,
  FaArrowRight,
  FaChevronDown,
  FaChevronUp,
  FaExclamationCircle,
} from 'react-icons/fa';
import withAuth from '../../auth/WithAuth';
import { toast } from 'react-toastify';
import './payments.scss';
import { serverUrlAuth } from '../../../serverUrl';
import Sidebar from '../../../components/layout/Sidebar';

const ArtisanDisbursements = () => {
  const [payouts, setPayouts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showDetailModal, setShowDetailModal] = useState(false);
  const [selectedDisbursement, setSelectedDisbursement] = useState(null);
  const [disbursementDetail, setDisbursementDetail] = useState(null);
  const [detailLoading, setDetailLoading] = useState(false);
  const [expandedProjects, setExpandedProjects] = useState({});
  const [filters, setFilters] = useState({
    search: '',
  });

  // Stats
  const [stats, setStats] = useState({
    total_payouts: 0,
    total_amount: 0,
    total_disbursed: 0,
    pending_count: 0,
    partially_paid_count: 0,
    paid_count: 0,
  });

  useEffect(() => {
    fetchPayouts();
  }, []);

  const fetchPayouts = async () => {
    setLoading(true);
    try {
      const response = await serverUrlAuth.get('disbursement/my-payouts/');

      let data = response.data;
      let payoutsList = [];

      // Handle new data structure
      if (data.payouts && Array.isArray(data.payouts)) {
        payoutsList = data.payouts;
      } else if (data.disbursements && Array.isArray(data.disbursements)) {
        // Fallback for old structure
        payoutsList = groupDisbursementsByPayout(data.disbursements);
      } else if (Array.isArray(data)) {
        payoutsList = data;
      }

      setPayouts(payoutsList);

      // Auto-expand projects with pending/partially paid status
      const initialExpanded = {};
      payoutsList.forEach((payout) => {
        if (payout.status === 'pending' || payout.status === 'partially_paid') {
          initialExpanded[payout.id] = true;
        }
      });
      setExpandedProjects(initialExpanded);

      updateStats(payoutsList);
    } catch (error) {
      console.error('Error fetching payouts:', error);
      toast.error('Failed to load payment history');
      setPayouts([]);
    } finally {
      setLoading(false);
    }
  };

  // Fallback: Group disbursements by payout (for old API structure)
  const groupDisbursementsByPayout = (disbursementsList) => {
    const groups = {};

    disbursementsList.forEach((disb) => {
      const key = disb.payout || disb.payout_id || 'unknown';

      if (!groups[key]) {
        groups[key] = {
          id: key,
          project_name: disb.project_name || 'Unknown Project',
          project_id: disb.project_id || 'N/A',
          artisan_name: disb.artisan_name || 'N/A',
          status: disb.payout_status || 'pending',
          artisan_amount: parseFloat(disb.artisan_amount || 0),
          amount_disbursed: 0,
          amount_remaining: 0,
          disbursements: [],
          created_at: disb.created_at || disb.disbursed_at,
        };
      }

      groups[key].disbursements.push(disb);
      groups[key].amount_disbursed += parseFloat(disb.amount || 0);
      groups[key].amount_remaining =
        groups[key].artisan_amount - groups[key].amount_disbursed;

      // Update status based on disbursements
      const totalAmount = groups[key].artisan_amount;
      const totalDisbursed = groups[key].amount_disbursed;

      if (totalDisbursed === 0) {
        groups[key].status = 'pending';
      } else if (totalDisbursed < totalAmount) {
        groups[key].status = 'partially_paid';
      } else {
        groups[key].status = 'paid';
      }
    });

    return Object.values(groups).sort((a, b) => {
      return new Date(b.created_at) - new Date(a.created_at);
    });
  };

  const updateStats = (data) => {
    const total_payouts = data.length;
    const total_amount = data.reduce(
      (sum, p) => sum + parseFloat(p.artisan_amount || 0),
      0
    );
    const total_disbursed = data.reduce(
      (sum, p) => sum + parseFloat(p.amount_disbursed || 0),
      0
    );
    const pending_count = data.filter((p) => p.status === 'pending').length;
    const partially_paid_count = data.filter(
      (p) => p.status === 'partially_paid'
    ).length;
    const paid_count = data.filter((p) => p.status === 'paid').length;

    setStats({
      total_payouts,
      total_amount,
      total_disbursed,
      pending_count,
      partially_paid_count,
      paid_count,
    });
  };

  const fetchDisbursementDetail = async (disbursementId) => {
    setDetailLoading(true);
    try {
      const response = await serverUrlAuth.get(
        `disbursement/my-disbursements/${disbursementId}/`
      );

      let data = response.data;

      // Handle nested data structure
      if (data.disbursement) {
        data = data.disbursement;
      }

      setDisbursementDetail(data);
    } catch (error) {
      console.error('Error fetching disbursement details:', error);
      toast.error('Failed to load payment details');
    } finally {
      setDetailLoading(false);
    }
  };

  const handleViewDetails = (disbursement) => {
    setSelectedDisbursement(disbursement);
    setShowDetailModal(true);
    fetchDisbursementDetail(disbursement.id);
  };

  const handleCloseDetailModal = () => {
    setShowDetailModal(false);
    setSelectedDisbursement(null);
    setDisbursementDetail(null);
  };

  const toggleProjectExpansion = (payoutId) => {
    setExpandedProjects((prev) => ({
      ...prev,
      [payoutId]: !prev[payoutId],
    }));
  };

  const filteredPayouts = payouts.filter((payout) => {
    // Search filter
    if (filters.search) {
      const search = filters.search.toLowerCase();
      return (
        payout.project_name?.toLowerCase().includes(search) ||
        payout.id?.toString().includes(search) ||
        payout.artisan_name?.toLowerCase().includes(search)
      );
    }
    return true;
  });

  const getStatusConfig = (status) => {
    const configs = {
      pending: {
        label: 'Pending',
        icon: FaClock,
        className: 'status-pending',
        color: '#F59E0B',
        bg: '#FEF3C7',
      },
      partially_paid: {
        label: 'Partially Paid',
        icon: FaExclamationCircle,
        className: 'status-partial',
        color: '#3B82F6',
        bg: '#DBEAFE',
      },
      paid: {
        label: 'Fully Paid',
        icon: FaCheckCircle,
        className: 'status-paid',
        color: '#10B981',
        bg: '#D1FAE5',
      },
    };
    return configs[status] || configs.pending;
  };

  const getPaymentMethodIcon = (method) => {
    if (method === 'mpesa') return '📱';
    if (method === 'bank') return '🏦';
    return '💰';
  };

  const getPaymentMethodLabel = (method) => {
    if (method === 'mpesa') return 'M-Pesa';
    if (method === 'bank') return 'Bank Transfer';
    return method || 'N/A';
  };

  const getStageLabel = (stage) => {
    const stages = {
      deposit: 'Deposit',
      deposit_initial: 'Deposit - Initial',
      deposit_progress: 'Deposit - Progress',
      balance_initial: 'Balance - Initial',
      balance_final: 'Balance - Final',
    };
    return stages[stage] || stage || 'N/A';
  };

  const formatCurrency = (amount) => {
    if (amount === undefined || amount === null || isNaN(amount))
      return 'KES 0.00';
    return new Intl.NumberFormat('en-KE', {
      style: 'currency',
      currency: 'KES',
      minimumFractionDigits: 2,
    }).format(parseFloat(amount));
  };

  const formatDate = (date) => {
    if (!date) return 'N/A';
    try {
      return new Date(date).toLocaleDateString('en-KE', {
        year: 'numeric',
        month: 'short',
        day: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
      });
    } catch {
      return 'N/A';
    }
  };

  const formatDateShort = (date) => {
    if (!date) return 'N/A';
    try {
      return new Date(date).toLocaleDateString('en-KE', {
        year: 'numeric',
        month: 'short',
        day: 'numeric',
      });
    } catch {
      return 'N/A';
    }
  };

  if (loading) {
    return (
      <>
        <Sidebar />
        <div className="modern-dashboard artisan-disbursements">
          <div className="loading-container">
            <div className="loading-spinner"></div>
            <p>Loading your payments...</p>
          </div>
        </div>
      </>
    );
  }

  return (
    <>
      <Sidebar />
      <div className="modern-dashboard artisan-disbursements">
        {/* ============================================================
            HERO SECTION — rich floating circles
           ============================================================ */}
        <section className="hero-banner">
          <div className="hero-pattern"></div>

          {/* 10 floating circles */}
          <span className="hero-circle hero-circle-1"></span>
          <span className="hero-circle hero-circle-2"></span>
          <span className="hero-circle hero-circle-3"></span>
          <span className="hero-circle hero-circle-4"></span>
          <span className="hero-circle hero-circle-5"></span>
          <span className="hero-circle hero-circle-6"></span>
          <span className="hero-circle hero-circle-7"></span>
          <span className="hero-circle hero-circle-8"></span>
          <span className="hero-circle hero-circle-9"></span>
          <span className="hero-circle hero-circle-10"></span>

          <div className="hero-overlay">
            <div className="hero-content">
              <h1>
                <span className="gradient-text">💳 My</span> Payments
              </h1>
              <p>View all your payment history grouped by project</p>
            </div>
          </div>
        </section>

        {/* ============================================================
            STATS CARDS
           ============================================================ */}
        <div className="stats-overview">
          <div className="stat-card total">
            <div className="stat-icon">
              <FaProjectDiagram />
            </div>
            <div className="stat-info">
              <h3>Total Projects</h3>
              <p className="stat-value">{stats.total_payouts}</p>
            </div>
          </div>
          <div className="stat-card amount">
            <div className="stat-icon">
              <FaWallet />
            </div>
            <div className="stat-info">
              <h3>Total Amount</h3>
              <p className="stat-value">
                {formatCurrency(stats.total_amount)}
              </p>
            </div>
          </div>
          <div className="stat-card amount">
            <div className="stat-icon">
              <FaMoneyBillWave />
            </div>
            <div className="stat-info">
              <h3>Total Received</h3>
              <p className="stat-value">
                {formatCurrency(stats.total_disbursed)}
              </p>
            </div>
          </div>
          <div className="stat-card pending">
            <div className="stat-icon">
              <FaClock />
            </div>
            <div className="stat-info">
              <h3>Pending</h3>
              <p className="stat-value">{stats.pending_count}</p>
            </div>
          </div>
          <div className="stat-card partial">
            <div className="stat-icon">
              <FaExclamationCircle />
            </div>
            <div className="stat-info">
              <h3>Partially Paid</h3>
              <p className="stat-value">{stats.partially_paid_count}</p>
            </div>
          </div>
          <div className="stat-card paid">
            <div className="stat-icon">
              <FaCheckCircle />
            </div>
            <div className="stat-info">
              <h3>Fully Paid</h3>
              <p className="stat-value">{stats.paid_count}</p>
            </div>
          </div>
        </div>

        {/* ============================================================
            FILTERS
           ============================================================ */}
        <div className="filters-section">
          <div className="filters-bar">
            <div className="search-box">
              <FaSearch className="search-icon" />
              <input
                type="text"
                placeholder="Search by project name or ID..."
                value={filters.search}
                onChange={(e) =>
                  setFilters((prev) => ({ ...prev, search: e.target.value }))
                }
              />
            </div>

            <div className="filter-actions">
              <span className="results-count">
                {filteredPayouts.length} of {payouts.length} projects
              </span>
              <button className="btn btn-refresh" onClick={fetchPayouts}>
                Refresh
              </button>
            </div>
          </div>
        </div>

        {/* ============================================================
            GROUPED PAYOUTS LIST
           ============================================================ */}
        <div className="disbursements-section">
          <div className="disbursements-container">
            {filteredPayouts.length === 0 ? (
              <div className="empty-state">
                <div className="empty-icon">💰</div>
                <h3>No payments found</h3>
                <p>
                  You haven't received any payments yet, or no projects match
                  your current search.
                </p>
              </div>
            ) : (
              <div className="project-groups">
                {filteredPayouts.map((payout) => {
                  const statusConfig = getStatusConfig(payout.status);
                  const StatusIcon = statusConfig.icon;
                  const isExpanded = expandedProjects[payout.id] || false;
                  const totalDisbursements = payout.disbursements?.length || 0;
                  const remaining = parseFloat(payout.amount_remaining) || 0;

                  return (
                    <div key={payout.id} className="project-group-card">
                      {/* Project Header */}
                      <div
                        className="project-header"
                        onClick={() => toggleProjectExpansion(payout.id)}
                      >
                        <div className="project-header-left">
                          <div className="project-icon">
                            <FaProjectDiagram />
                          </div>
                          <div className="project-info">
                            <h3 className="project-name">
                              {payout.project_name}
                            </h3>
                            <div className="project-meta">
                              <span className="project-id">
                                Project #{payout.project_id}
                              </span>
                              <span className="project-stage">
                                {getStageLabel(payout.payout_stage)}
                              </span>
                              <span className="project-payments-count">
                                {totalDisbursements} payment
                                {totalDisbursements !== 1 ? 's' : ''}
                              </span>
                            </div>
                          </div>
                        </div>
                        <div className="project-header-right">
                          <div className="project-amounts">
                            <div className="amount-total">
                              <span className="label">Total</span>
                              <span className="value">
                                {formatCurrency(payout.artisan_amount)}
                              </span>
                            </div>
                            <div className="amount-disbursed">
                              <span className="label">Received</span>
                              <span className="value">
                                {formatCurrency(payout.amount_disbursed)}
                              </span>
                            </div>
                            {remaining > 0 && (
                              <div className="amount-remaining">
                                <span className="label">Pending</span>
                                <span className="value">
                                  {formatCurrency(remaining)}
                                </span>
                              </div>
                            )}
                          </div>
                          <div className="project-status">
                            <span
                              className={`status-badge ${statusConfig.className}`}
                            >
                              <StatusIcon /> {statusConfig.label}
                            </span>
                          </div>
                          <div className="expand-icon">
                            {isExpanded ? <FaChevronUp /> : <FaChevronDown />}
                          </div>
                        </div>
                      </div>

                      {/* Disbursement List (Expandable) */}
                      {isExpanded &&
                        payout.disbursements &&
                        payout.disbursements.length > 0 && (
                          <div className="disbursement-list">
                            {payout.disbursements.map((disb, index) => (
                              <div key={disb.id} className="disbursement-item">
                                <div className="disbursement-index">
                                  #{index + 1}
                                </div>
                                <div className="disbursement-details">
                                  <div className="disb-amount">
                                    <span className="amount">
                                      {formatCurrency(disb.amount)}
                                    </span>
                                    <span
                                      className={`method-badge ${disb.payment_method}`}
                                    >
                                      {getPaymentMethodIcon(
                                        disb.payment_method
                                      )}{' '}
                                      {getPaymentMethodLabel(
                                        disb.payment_method
                                      )}
                                    </span>
                                  </div>
                                  <div className="disb-info">
                                    <span className="disb-reference">
                                      <FaReceipt className="info-icon" />
                                      {disb.transaction_reference || 'N/A'}
                                    </span>
                                    <span className="disb-date">
                                      <FaCalendarAlt className="info-icon" />
                                      {formatDateShort(disb.disbursed_at)}
                                    </span>
                                    {disb.notes && (
                                      <span className="disb-notes">
                                        📝 {disb.notes}
                                      </span>
                                    )}
                                  </div>
                                </div>
                                <div className="disbursement-actions">
                                  <button
                                    className="btn btn-sm btn-view"
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      handleViewDetails(disb);
                                    }}
                                  >
                                    <FaEye /> View
                                  </button>
                                </div>
                              </div>
                            ))}
                          </div>
                        )}

                      {/* No disbursements message */}
                      {isExpanded &&
                        (!payout.disbursements ||
                          payout.disbursements.length === 0) && (
                          <div className="disbursement-list empty">
                            <div className="empty-disbursements">
                              <p>No disbursements recorded yet.</p>
                            </div>
                          </div>
                        )}
                    </div>
                  );
                })}
              </div>
            )}
          </div>
        </div>

        {/* ============================================================
            DETAIL MODAL
           ============================================================ */}
        {showDetailModal && selectedDisbursement && (
          <div className="modal-overlay" onClick={handleCloseDetailModal}>
            <div
              className="modal-content detail-modal"
              onClick={(e) => e.stopPropagation()}
            >
              <div className="modal-header">
                <div className="modal-title">
                  <FaReceipt className="modal-icon" />
                  <div>
                    <h2>Payment Details</h2>
                    <p>Transaction #{selectedDisbursement.id}</p>
                  </div>
                </div>
                <button
                  className="close-modal"
                  onClick={handleCloseDetailModal}
                >
                  <FaTimes />
                </button>
              </div>

              {detailLoading ? (
                <div className="detail-loading">
                  <div className="loading-spinner-small"></div>
                  <p>Loading details...</p>
                </div>
              ) : disbursementDetail ? (
                <div className="detail-content">
                  {/* Payment Summary */}
                  <div className="detail-summary-card">
                    <div className="summary-amount">
                      <span className="amount-label">Amount Received</span>
                      <span className="amount-value">
                        {formatCurrency(disbursementDetail.amount)}
                      </span>
                    </div>
                    <div className="summary-method">
                      <span className="method-icon">
                        {getPaymentMethodIcon(
                          disbursementDetail.payment_method
                        )}
                      </span>
                      <span className="method-label">
                        {getPaymentMethodLabel(
                          disbursementDetail.payment_method
                        )}
                      </span>
                    </div>
                  </div>

                  {/* Project Info */}
                  <div className="detail-section">
                    <h3 className="section-title">
                      <FaProjectDiagram /> Project Information
                    </h3>
                    <div className="detail-grid">
                      <div className="detail-item">
                        <span className="label">Project Name</span>
                        <span className="value">
                          {disbursementDetail.project_name || 'N/A'}
                        </span>
                      </div>
                      <div className="detail-item">
                        <span className="label">Project ID</span>
                        <span className="value">
                          #{disbursementDetail.project_id || 'N/A'}
                        </span>
                      </div>
                      <div className="detail-item">
                        <span className="label">Payout Stage</span>
                        <span className="value stage-badge">
                          {getStageLabel(disbursementDetail.payout_stage)}
                        </span>
                      </div>
                      <div className="detail-item">
                        <span className="label">Total Payout Amount</span>
                        <span className="value highlight-amount">
                          {formatCurrency(disbursementDetail.artisan_amount)}
                        </span>
                      </div>
                    </div>
                  </div>

                  {/* Transaction Details */}
                  <div className="detail-section">
                    <h3 className="section-title">
                      <FaWallet /> Transaction Details
                    </h3>
                    <div className="detail-grid">
                      <div className="detail-item">
                        <span className="label">Transaction Reference</span>
                        <span className="value highlight-ref">
                          {disbursementDetail.transaction_reference || 'N/A'}
                        </span>
                      </div>
                      <div className="detail-item">
                        <span className="label">Payment Method</span>
                        <span className="value">
                          <span
                            className={`method-badge ${disbursementDetail.payment_method}`}
                          >
                            {getPaymentMethodIcon(
                              disbursementDetail.payment_method
                            )}{' '}
                            {getPaymentMethodLabel(
                              disbursementDetail.payment_method
                            )}
                          </span>
                        </span>
                      </div>
                      <div className="detail-item">
                        <span className="label">Disbursed At</span>
                        <span className="value">
                          {formatDate(
                            disbursementDetail.disbursed_at ||
                              disbursementDetail.created_at
                          )}
                        </span>
                      </div>
                      {disbursementDetail.notes && (
                        <div className="detail-item full-width">
                          <span className="label">Notes</span>
                          <span className="value notes-text">
                            {disbursementDetail.notes}
                          </span>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              ) : (
                <div className="detail-error">
                  <p>Failed to load payment details.</p>
                </div>
              )}

              <div className="modal-footer">
                <button
                  className="btn btn-secondary"
                  onClick={handleCloseDetailModal}
                >
                  Close
                </button>
              </div>
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default withAuth(ArtisanDisbursements, 'artisan');